import $ from 'jquery'
import prop from 'vue-strict-prop'
import { component } from 'vue-tsx-support'

/**
 * A sidebar hides additional content beside a page.
 */
export default component({
	name: 'Sidebar',
	props: {
		attachEvents: prop(String).optional,
	},
	mounted(): void {
		$(this.$el).sidebar()

		if (this.attachEvents) {
			$(this.$el).sidebar('attach events', this.attachEvents)
		}
	},
	methods: {
		/**
		 * Hides sidebar.
		 */
		hide(): void {
			$(this.$el).sidebar('hide')
		},
		/**
		 * Shows sidebar.
		 */
		show(): void {
			$(this.$el).sidebar('show')
		},
	},
	render() {
		return (
			<div class="ui sidebar">
				{this.$slots.default}
			</div>
		)
	},
})
